module.exports = __webpack_public_path__ + "static/media/United-Kingdom.742fd8ad.png";